import * as React from 'react'
import { FC } from 'react'

import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { SalesFunnelFilterButton } from './Filters/SalesFunnelFilterButton'
import { SalesFunnelDialogContent } from './SalesFunnelDialogContent'
import { SettingsPage, PageHeader } from '@sales-center/components'

import Box from '@mui/material/Box'
interface Props {
  onClose: () => void
  open: boolean
}

export const SalesFunnelDialog: FC<Props> = (props) => {
  const { open, onClose } = props

  return (
    <FullScreenDialog
      closeButtonText="Close Sales Funnels"
      onClose={onClose}
      open={open}
    >
      <SettingsPage
        title="Sales Funnels"
        padding="0px"
        fullScreen
        headContent={
          <PageHeader>
            <Box marginLeft="auto">
              <SalesFunnelFilterButton />
            </Box>
          </PageHeader>
        }
      >
        <SalesFunnelDialogContent onClose={onClose} />
      </SettingsPage>
    </FullScreenDialog>
  )
}

SalesFunnelDialog.displayName = 'SalesFunnelDialog'
